@if (items) {
    <div class="market-row-wrapper">
        @if (getRowType(items) == 'product') {
            <div class="market-row">
                <!-- TODO: grab type/title of data from server-->
                <!-- <div class="market-row-title"> {{ rowData.slug }} </div> -->
                <div class="market-product-listing">
                    @for (product of items; track product) {
                        <div class="product-wrapper">
                            <!-- <div *ngIf="product?.isListed != false && product?.isVisible != false"><app-product-market-row-item [hideCrateButton]="displayOnMain"[item]="product"></app-product-market-row-item></div> -->
                            <app-product-market-row-item [hideCrateButton]="displayOnMain"[item]="product"></app-product-market-row-item>
                        </div>
                    }
                </div>
            </div>
        }
        @if (getRowType(items) == 'vendor') {
            <div class="market-row">
                <!-- TODO: grab type/title of data from server-->
                <!-- <div class="market-row-title"> {{ rowData.slug }} </div> -->
                <div class="market-product-listing">
                    @for (vendor of items; track vendor) {
                        <div class="vendor-wrapper">
                            <app-vendor-market-row [routeToRestaurant]="displayOnMain"[item]="vendor"></app-vendor-market-row>
                        </div>
                    }
                </div>
            </div>
        }
    </div>
}

